/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum NotificationStatus {
  SCHEDULED="SCHEDULED",
SENT="SENT",
FAILED="FAILED",
CANCELLED="CANCELLED",
UNDELIVERED="UNDELIVERED"
}

/**
* NotificationStatus
*/
export const NotificationStatusEnumType = types.enumeration("NotificationStatus", [
        "SCHEDULED",
  "SENT",
  "FAILED",
  "CANCELLED",
  "UNDELIVERED",
      ])
